import { TireRackItemI } from "../../types/store";

export const removeTireRack = (tireRackId: string, existingTireRacks: TireRackItemI[]): TireRackItemI[] => {
    return existingTireRacks.filter((tireRack) => tireRack.id !== tireRackId);
};
